var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 0.75C7.52344 0.75 8.4375 1.66406 8.4375 2.71875V16.7812C8.4375 17.8711 7.52344 18.75 6.46875 18.75C5.44922 18.75 4.60547 18.0117 4.5 16.9922C4.32422 17.0625 4.11328 17.0625 3.9375 17.0625C2.67188 17.0625 1.6875 16.0781 1.6875 14.8125C1.6875 14.5664 1.72266 14.3203 1.79297 14.0742C0.738281 13.6875 0 12.668 0 11.4375C0 10.3477 0.632812 9.36328 1.58203 8.90625C1.30078 8.51953 1.125 8.02734 1.125 7.5C1.125 6.44531 1.86328 5.53125 2.88281 5.32031C2.8125 5.10938 2.8125 4.89844 2.8125 4.6875C2.8125 3.66797 3.51562 2.75391 4.5 2.50781C4.60547 1.52344 5.44922 0.75 6.46875 0.75ZM11.5312 0.75C12.5156 0.75 13.3594 1.52344 13.4648 2.50781C14.4492 2.75391 15.1875 3.63281 15.1875 4.6875C15.1875 4.89844 15.1523 5.10938 15.082 5.32031C16.1016 5.53125 16.875 6.44531 16.875 7.5C16.875 8.02734 16.6641 8.51953 16.3828 8.90625C17.332 9.36328 18 10.3477 18 11.4375C18 12.668 17.2266 13.6875 16.1719 14.0742C16.2422 14.3203 16.3125 14.5664 16.3125 14.8125C16.3125 16.0781 15.293 17.0625 14.0625 17.0625C13.8516 17.0625 13.6406 17.0625 13.4648 16.9922C13.3594 18.0117 12.5156 18.75 11.5312 18.75C10.4414 18.75 9.5625 17.8711 9.5625 16.7812V2.71875C9.5625 1.66406 10.4414 0.75 11.5312 0.75Z",
    fill: "url(#paint0_linear_12032_36801)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12032_36801",
    x1: 0,
    y1: 9.75,
    x2: 18,
    y2: 9.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A791FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBrain);
export default __webpack_public_path__ + "static/media/ai-brain.ff9e31d8d966accbd4e07ba9872bcd08.svg";
export { ForwardRef as ReactComponent };